import React from 'react';
import withIcon from '../utilities/withIcon';

const IconBadge = () => {
  return (
    <g>
      <path d="M8.5 1A1.5 1.5 0 0 1 10 2.5V3h4a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4v-.5A1.5 1.5 0 0 1 7.5 1h1zM6 4.5H2a.5.5 0 0 0-.492.41L1.5 5v8a.5.5 0 0 0 .41.492L2 13.5h12a.5.5 0 0 0 .492-.41L14.5 13V5a.5.5 0 0 0-.41-.492L14 4.5h-4A1.5 1.5 0 0 1 8.5 6h-1A1.5 1.5 0 0 1 6 4.5zm0 2A1.5 1.5 0 0 1 7.5 8v3A1.5 1.5 0 0 1 6 12.5H4A1.5 1.5 0 0 1 2.5 11V8A1.5 1.5 0 0 1 4 6.5h2zM6 8H4v3h2V8zm6.25 1a.75.75 0 1 1 0 1.5h-2.5a.75.75 0 1 1 0-1.5h2.5zm0-2.5a.75.75 0 1 1 0 1.5h-2.5a.75.75 0 0 1 0-1.5h2.5zm-3.75-4h-1v2h1v-2z" />
    </g>
  );
};

export default withIcon(IconBadge);
